// extracted by mini-css-extract-plugin
module.exports = {"share-title":"create_share__share-title___2qSzf _type__vx_text-2___Qizsf","done-button":"create_share__done-button___3OXrr"};